import { makeStyles } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import PageWrapper from "../../components/PageWrapper";

import { linkToRecordReading } from "../../routes/record/links";

import {
  ALL_READING_TYPES,
  WHAT_LIES_BENEATH_WEB_LINK,
  getFullReadingName
} from "../../types/Readings/Shared";

import { linkToMap } from "custom/config";
import ReminderSummary from "pages/readings/upload/common/ReminderSummary";

const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: `${theme.spacing(2)}px`
  },
  divider: {
    margin: theme.spacing(1)
  },
  header: {
    fontWeight: "bold"
  },
  textBody: {
    marginBottom: `${theme.spacing(2)}px`
  },
  wrapper: {
    display: "flex",
    flexFlow: "column",
    padding: theme.spacing(2),
    height: "100%"
  }
}));

const WaterTestResultsHome = () => {
  const classes = useStyles();
  const history = useHistory();
  const handleClose = () => history.push(linkToMap());

  const goToUpload = (readingType: string) => {
    history.push(linkToRecordReading(readingType));
  };

  return (
    <PageWrapper
      label={"Water quality testing"}
      navigationHandler={{ handleClose: handleClose }}
    >
      <div className={classes.wrapper}>
        <ReminderSummary />
        <div className={classes.header}>Choose a reading type to begin</div>
        <br />
        {ALL_READING_TYPES.map((readingType: string) => (
          <Button
            variant="contained"
            size="large"
            disableElevation
            key={`${readingType}UploadButton`}
            className={classes.button}
            color="primary"
            onClick={() => goToUpload(readingType)}
          >
            {getFullReadingName(readingType)}
          </Button>
        ))}
        <Divider className={classes.divider} />
        <div className={classes.textBody}>
          Order your test kit to help us measure water quality in a river,
          stream, lake or canal near you.
        </div>
        <Button
          variant="contained"
          size="large"
          disableElevation
          className={classes.button}
          color="primary"
          onClick={() => window.open(WHAT_LIES_BENEATH_WEB_LINK)}
        >
          Request test kit
        </Button>
      </div>
    </PageWrapper>
  );
};

export default WaterTestResultsHome;
